import React from 'react';
import Template1 from '../Shared/Template1/PVTemplate1WithForm';
import content from './json/PVDigitalDatabase.json';

const PVDigitalDatabase = () => {
    return <Template1 data={content} />;
};

export default PVDigitalDatabase;
